module.exports = __webpack_public_path__ + "assets/img/loginicon.76692a03.png";